import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { globalFunction } from "../../Helpers/globalFunctions";
import PointModal from "../Dashboard/PointModal";
import RoundModal from "../ModalBox/RoundModal";

const CommonHeader = (props) => {
  const { get_round } = useSelector((state) => state.common);
  const [isActive, setIsActive] = useState(false);
  const [defaultClass, setDefaultClass] = useState("show-more down-arrow");
  const [smallBanner, setSmallBannerClass] = useState("smallbanner");
  const handleMinimizeView = () => {
    if (isActive) {
      setSmallBannerClass("smallbanner");
      setDefaultClass("down-arrow");
      setIsActive(false);
    } else {
      setSmallBannerClass("");
      setDefaultClass("show-more down-arrow");
      setIsActive(true);
    }
  };
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  const brandingDetails = JSON.parse(localStorage.getItem("branding"));
  const location = useLocation();
  const pathnameSegments = location.pathname.split("/");
  const firstSegment = pathnameSegments[1];
  const hideHeaderOnPaths = [
    "update-profile",
    "change-password",
    "game-accounts",
    "login",
    "game-signup",
    "pricing",
    "refund",
    "how-to-play",
    "how-it-works",
    "privacy",
    "terms-of-use",
    "rules",
    "faqs",
    "showcase",
    "my-games",
    "join-game",
    "live-games",
    "member-signup",
    "start-game",
    "account-hub",
    "about-us",
    "dashboard",
    "features",
    "forgot-password",
    "account-verification",
    "custom-game-register",
    "testimonials",
    "reset-password",
    "not-found",
    "adminLogin",
    "my-player-profile",
    "member-profile",
    "feature-details",
    "whats-new",
    "whats-new",
    "press-release",
    "whats-new-detail",
    "press-detail",
    "game-rank",
    "game-players",
    "game-player-profile",
    "guest-game-charts",
    "articles",
    "",
  ];
  const hideHeader = hideHeaderOnPaths.includes(firstSegment);
  const [showPointModal, setShowPointModal] = useState(false);
  const [gradeList, setGradeList] = useState([]);
  const handleShowPointModal = (e) => {
    e.preventDefault();
    globalFunction(setShowPointModal, setGradeList);
  };

  const [showRoundModal, setShowRoundModal] = useState(false);
  const handleShowRoundModal = (e) => {
    e.preventDefault();
    setShowRoundModal(true);
  };
  return (
    <>
      {!hideHeader && (
        <>
          <div className={`${smallBanner} banner-section`}>
            <div className="banner-content">
              <div className="left-section">
                <figure>
                  {/* <img src={`/images/club-logo.png`} alt="img" /> */}
                  {clubDetails && (
                    <img
                      src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${clubDetails?.logo}`}
                      alt="img"
                    />
                  )}
                  {!clubDetails && (
                    <img src={`/images/club-logo.png`} alt="img" />
                  )}
                </figure>
                <div className="gamebar_detail">
                  <span className="custom-select">
                    {clubDetails?.game_name}
                  </span>
                  <ul className="game-btn">
                    <li>
                      <Link to="/dashboard">
                        <img src={`/images/dashboard.svg`} alt="img" />
                        Dashboard
                      </Link>
                    </li>
                    <li>
                      <Link id="gamemenu" onClick={props.gameMenuClick}>
                        <img src="/images/menu-icon.png" alt="img" />
                        Game Menu
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="right-section">
                {/* <div className="banner-ads">
            <figure className="webads">
              <Link href="">
                <img src={`/images/banner-ads.jpg`} alt="img" />
              </Link>
            </figure>
          </div> */}
                <div className="brand-logo">
                  <figure className="webads">
                    <Link onClick={handleMinimizeView}>
                      {brandingDetails && (
                        <img
                          src={`${process.env.REACT_APP_UPLOAD_URL}branding/${brandingDetails?.logo}`}
                          alt="img"
                        />
                      )}
                      {!brandingDetails && (
                        <img src={`/images/brand-logo.png`} alt="img" />
                      )}
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
            <Link className={defaultClass} onClick={handleMinimizeView}>
              <img src="/images/down-arrow.svg" alt="img" />
            </Link>
          </div>
          <div className="gamemenu-section">
            <div id="gameMenuId" className={props.gameMenuLink}>
              <figure className="menulogo">
                <img src="/images/logo.png" alt="img" />
              </figure>
              <div className="left-section">
                <figure>
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${clubDetails?.logo}`}
                    alt="img"
                  />
                </figure>
                <div className="gamebar_detail" style={{ color: "white" }}>
                  {clubDetails?.game_name}
                </div>
              </div>
              <Link
                onClick={(e) => e.preventDefault()}
                className="close"
                id="closemenu"
              >
                <img src={`/images/close-icon.png`} alt="img" />
              </Link>
              <ul>
                <li>
                  <Link to={"/about-game"}>About Game</Link>
                </li>
                <li>
                  <Link to="/dashboard">My Dashboard</Link>
                </li>
                <li>
                  <Link to="/my-team">My Team</Link>
                </li>
                <li>
                  <Link to="/my-players">My Players</Link>
                </li>
                <li>
                  <Link to="/rounds">Round Team</Link>
                </li>
                {/* <li>
              <Link to="/history" >
                History
              </Link>
            </li> */}
                <li>
                  <Link to="/rank">Rank</Link>
                </li>
                <li>
                  <Link to="/players">Players</Link>
                </li>
                <li>
                  <Link to="/player-charts">Player Chart</Link>
                </li>
                <li>
                  <Link to="/timeline">Timeline</Link>
                </li>
                {clubDetails?.is_bracket_battle_activate === 1 && (
                  <li>
                    <Link to="/bracket-battle">Bracket Battle</Link>
                  </li>
                )}
                {clubDetails?.is_bonus_card_activate === 1 && (
                  <li>
                    <Link to="/bonus-card">Bonus Card</Link>
                  </li>
                )}
                {clubDetails?.is_totr_activate === 1 && (
                  <li>
                    <Link to="/team-of-the-round">TOTR</Link>
                  </li>
                )}
                {clubDetails?.is_h2h_activate === 1 && (
                  <li>
                    <Link to="/head-2-head">Head-2-Head</Link>
                  </li>
                )}

                <li>
                  <Link to="/stats">Stats</Link>
                </li>

                <li>
                  <Link to="/fixtures">Fixtures</Link>
                </li>
                <li>
                  <Link to="/game-articles">Articles</Link>
                </li>
                <li>
                  <Link to="/notifications">Notifications & Alerts</Link>
                </li>
                <li>
                  <Link to="/sponsors">Sponsors</Link>
                </li>
                <li>
                  <Link to="/player-sponsors">Player Sponsors</Link>
                </li>
                {/* <li>
              <Link to="game-stats" >
                Game Stats
              </Link>
            </li> */}
                <li>
                  <Link to="/game-members">Game Members</Link>
                </li>
                <li>
                  <Link to="/trade-history">Trade History</Link>
                </li>
                <li>
                  <Link to="/game-charts">Game Charts</Link>
                </li>

                {clubDetails?.is_team_activate === 1 && (
                  <li>
                    <Link to="/game-teams">Game Teams</Link>
                  </li>
                )}
                <li>
                  <Link to="/rules">Rules</Link>
                </li>
                <li>
                  <Link to="/faqs">FAQs</Link>
                </li>
                <li>
                  <Link to="/how-to-play">How To Play</Link>
                </li>
                <li>
                  <Link
                    onClick={(e) => {
                      handleShowPointModal(e);
                    }}
                  >
                    Points System
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={(e) => {
                      handleShowRoundModal(e);
                    }}
                  >
                    Rounds/Trade Windows
                  </Link>
                </li>
                <li>
                  <Link
                    className="dropdown-item"
                    to={`https://myclubtap.tawk.help/category/for-members`}
                    target="_blank"
                  >
                    Help Center
                  </Link>
                </li>
                {/*
            <li>
              <Link to="/articles" >
                Articles
              </Link>
            </li>
            <li>
              <Link to="/team-of-the-week" >
                TOTR
              </Link>
            </li>
            <li>
              <Link to="/bonus-card" >
                Bonus Card
              </Link>
            </li> */}
              </ul>
            </div>
            <div className={props.gameMenuOverlay}></div>
          </div>
        </>
      )}
      <PointModal
        visible={showPointModal}
        setVisible={setShowPointModal}
        gradeList={gradeList}
      />
      <RoundModal
        round_data={get_round}
        visible={showRoundModal}
        setVisible={setShowRoundModal}
      />
    </>
  );
};

export default CommonHeader;
